<template>
  <div class="form-helper-container">
    <FormHelper class="form-container" @callback="callback" :formSettings="formSettings"/>
  </div>
</template>

<script>

import FormHelper from '@/components/common/FormHelper';

export default {
  components: {
    FormHelper
  },
  data () {
    return {
      formSettings: { //フォームの設定を記載
        store: 'user',
        dispatch: 'register',
        header: 'ユーザー登録',
        forms: {
          name: {
            label: '名前',
            type: 'text',
            value: null,
            require: true,
            placeholder: 'お名前',
            default: '',
            validate: [],
            option: {
              size: 300,
            }
          },
          password: {
            label: 'パスワード',
            type: 'password',
            value: null,
            require: true,
            placeholder: '英数字記号 8文字以上',
            default: '',
            validate: [],
            option: {
              size: 300,
            }
          },
          password_confirmation: {
            label: 'パスワード(確認)',
            type: 'password',
            value: null,
            require: true,
            placeholder: '',
            default: '',
            validate: [
              'password_confirmation'
            ],
            option: {
              size: 300,
            }
          },
          v: {
            label: null,
            type: 'hidden',
            value: null,
            require: null,
            placeholder: '',
            default: '',
            validate: [],
            option: {}
          }
        },
        useSessionId: false,
        submit: {
          label: 'ユーザー登録',
          color: 'b'
        },
        info: [], // フォーム下部の補足説明
        reasonCode: {
        },
        noValidationErrorMessage: false
      },
      option: {
        is1Button: true,
        buttonLabel: '閉じる',
        callback: 'Finish',
        callbackO: 'Finish',
        messages: ['登録が完了しました']
      },
      optionTokenError: {
        is1Button: true,
        buttonLabel: '閉じる',
        buttonColor: 'b',
        callback: 'TokenError',
        callbackO: 'close',
        messages: ['サインインリンクの有効期限が切れました', '再度、サインインの手続きを行ってください']
      },
      lock: false
    };
  },
  created: function (){
    this.emailVerify();
  },
  watch: {
    lock: function () {
      // ローディング表示
      if (this.lock === true) {
        this.$store.dispatch('loading/open').then();
      } else {
        this.$store.dispatch('loading/close').then();
      }

    },
    callbackDispatcher: function () {
      console.log(this.callbackDispatcher);

      if (this.callbackDispatcher === 'Finish') {
        // Homeへ遷移
        this.$router.push({name: 'Home'});
      } else if (this.callbackDispatcher === 'TokenError') {
        // welcomeへ遷移
        this.$router.push({name: 'Welcome'});
      }
    }
  },
  computed: {
    callbackDispatcher: function () {
      return this.$store.getters['message/callback'];
    }
  },
  methods: {
    emailVerify: function () {
      console.log('emailVerify');

      let token = this.$route.params.token;

      this.formSettings.forms.v.value = token;

      let params = {v: token};
      console.log(params);

      // ロック
      this.lock = true;

      this.$store.dispatch('user/verify', params).then(() => {

        let status = this.$store.getters['user/status'];

        if (status !== 200) {

// // 期限切れメッセージ
// this.$store.dispatch('message/open', this.optionTokenError).then();
        }

        // ロック解除
        this.lock = false;

      }).catch((err) => {
        console.warn(err);

        // ロック解除
        this.lock = false;

        this.$store.dispatch('errorInfo/setSystemErrorMessage').then();
        this.$router.push({name: 'UserSystemError'});
      });
    },
    callback: function (dispatcher, value) {
      console.log(dispatcher, value);

      if (dispatcher === 'FormHelperFinish') {

        let response = this.$store.getters[this.formSettings.store + '/response'];
        // console.log(response);

        // ログイン情報セット
        this.$store.dispatch('auth/registerFinish', response).then();

        // 完了メッセージ
        this.$store.dispatch('message/open', this.option).then();

      } else if (dispatcher === 'FormHelperNotice') {
        let reasonCode = this.$store.getters[this.formSettings.store + '/reasonCode'];
        console.log(reasonCode);

        if (reasonCode === 'TOKEN_NOT_MATCH') {

          // 期限切れメッセージ
          this.$store.dispatch('message/open', this.optionTokenError).then();

        } else{
          this.$store.dispatch('errorInfo/setErrorStore', this.formSettings.store).then();
          this.$router.push({name: 'UserSystemError'});
        }

      }
    }
  }
};

</script>

<style lang="scss" scoped>

  // 801以上
  @media screen and (min-width: 801px) {

    .form-helper-container {
      margin-top: 120px;
    }

    .form-container {
      border: 1px solid #ddd;
    }

  }

  // 800まで
  @media screen and (max-width: 800px) {

    .form-helper-container {
      margin-top: 10px;
    }

  }

</style>
